/**
 * Dashboard MV2 query API — isolated from MV1 Dashboard.jsx.
 */
import { getDashboard } from "@/lib/api";

export const DASHBOARD_QUERY_KEY = "dashboard";

export async function fetchDashboardFromApi(signal) {
  const response = await getDashboard();
  if (signal?.aborted) throw new DOMException("Aborted", "AbortError");
  return response.data;
}
